import { render, staticRenderFns } from "./stepNavigation.vue?vue&type=template&id=22ed6baf&scoped=true"
import script from "./stepNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./stepNavigation.vue?vue&type=script&setup=true&lang=js"
import style0 from "./stepNavigation.vue?vue&type=style&index=0&id=22ed6baf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed6baf",
  null
  
)

export default component.exports